const CONV_CACHE_PREFIX = 'wn-conv-cache';

function buildConvCacheKey(userId: string, groupingId: string): string {
  return `${CONV_CACHE_PREFIX}:${userId}:${groupingId}`;
}

export function getCachedConvId(
  userId: string | undefined,
  groupingId: string | undefined
): string | undefined {
  try {
    if (!userId || !groupingId) {
      return undefined;
    }
    return localStorage.getItem(buildConvCacheKey(userId, groupingId)) ?? undefined;
  } catch {
    return undefined;
  }
}

export function cacheConvId(
  userId: string | undefined,
  groupingId: string | undefined,
  chatId: string
): void {
  try {
    if (!userId || !groupingId) {
      return;
    }
    localStorage.setItem(buildConvCacheKey(userId, groupingId), chatId);
  } catch {
    // localStorage unavailable (e.g. Safari private mode) — silently skip
  }
}

export function clearCachedConvId(
  userId: string | undefined,
  groupingId: string | undefined
): void {
  try {
    if (!userId || !groupingId) {
      return;
    }
    localStorage.removeItem(buildConvCacheKey(userId, groupingId));
  } catch {
    // localStorage unavailable (e.g. Safari private mode) — silently skip
  }
}
